import { CalculusConditionDTO, RoundingRuleDTO } from '../../dtos';
import { PriceRoundingBrand } from '@retail/rounding/types';
import { dateFromString } from '@retail/utils';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { SupplierBase } from '@retail/suppliers/types';

interface RoundingRuleProps {
  id: number;
  name: string;
  centralOwner?: PriceRoundingBrand;
}

export class RoundingRuleSet {
  id: number;
  name: string;
  centralOwner?: PriceRoundingBrand;

  constructor({ id, name, centralOwner }: RoundingRuleProps) {
    this.id = id;
    this.name = name;
    this.centralOwner = centralOwner;
  }

  static fromDto = (dto: RoundingRuleDTO, selectedBrand: PriceRoundingBrand): RoundingRuleSet =>
    new RoundingRuleSet({
      id: dto.ruleSetId,
      name: dto.ruleSetName,
      centralOwner: dto.ruleSetType === 'BRAND' ? selectedBrand : undefined,
    });
}

export interface RoundingConditionProps extends ConditionBaseProps<RoundingCondition> {
  roundingRule: RoundingRuleSet;
}

export class RoundingCondition extends ItemConditionBase<RoundingCondition> {
  roundingRule: RoundingRuleSet;

  constructor({ roundingRule, ...superProps }: RoundingConditionProps) {
    super(superProps);
    this.roundingRule = roundingRule;
  }

  static fromDto = (
    dto: CalculusConditionDTO,
    selectedBrand: PriceRoundingBrand
  ): RoundingCondition => {
    const roundingRuleSet = dto.rounding ?? dto.roundingRuleSet;
    if (!roundingRuleSet) {
      throw new Error(`Condition id: ${dto.id} is missing rounding value`);
    }
    return new RoundingCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      roundingRule: RoundingRuleSet.fromDto(roundingRuleSet, selectedBrand),
    });
  };
}
